import React, { useState, useRef, useEffect, useContext } from "react";
import Webcam from "react-webcam";
import sound from "../../../Assets/Sounds/camerashutter6305.mp3";
import CamIcon from "../../../Assets/img/camera-icon.svg";
import { uploadImage } from "../../../_api";
import html2canvas from "html2canvas";
import Modal from "react-modal";
import {
  customModalStyles,
  photoboothName,
  webCamSettings,
} from "../../../utils/fixers";
import { saveAs } from "file-saver";
import Frames from "../../../Assets/Frames";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import Email from "../../../Assets/img/gmail.png";
import Facebook from "../../../Assets/img/facebook.png";
import Linkedin from "../../../Assets/img/linkedin.png";
import switchCamera from "../../../Assets/img/switch-camera.png";
import Twitter from "../../../Assets/img/twitter.png";
import Whatsapp from "../../../Assets/img/whatsapp.png";
import { ErrorContext } from "../../../context";
import ButtonLoader from "../../../components/ButtonLoader";
import useWindowDimensions from "../../../components/dimensions";
import bg1 from "../../../Assets/background/bg1.jpg"; // adjust path
import bg2 from "../../../Assets/background/bg2.jpg"; // adjust path
// import frame1 from "../../../Assets/Frames/frame1.png"; // adjust path
// import frame2 from "../../../Assets/Frames/frame2.png"; // adjust path
import { useParams } from "react-router-dom";

const APP_LINK = "https://digitaljollibee.com/panagbenga/menu-page";

export default function Capture() {
  const webCamRef = useRef(null);
  const imageFrameRef = useRef(null);
  const imageRef = useRef(null);
  const intervalRef = useRef(null);

  const { bg } = useParams();

  const { error, setError } = useContext(ErrorContext);

  const [tempImage, setTempImage] = useState(null);
  const [camera, setCamera] = useState("user");
  const [selectedFrame, selectFrame] = useState(Frames[0]); // eslint-disable-line
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [url, setUrl] = useState(null);
  const [camImage, setCamImage] = useState(null);
  const [camImageWithBg, setCamImageWithBg] = useState(null);
  const [progress, setProgress] = useState(0);
  const [imgCompress, setImgCompress] = useState(null);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageWidth, setImageWidth] = useState(0);
  const [upload, setUpload] = useState(false);

  const { height } = useWindowDimensions();

  function handleImageHeight() {
    setImageHeight(Math.max(imageRef.current.clientHeight, height * 0.9));
  }

  useEffect(() => {
    if (imageRef.current)
      setImageHeight(Math.max(imageRef.current.clientHeight, height * 0.9));
  }, [height, imageRef]);

  useEffect(() => {
    if (imageHeight) setImageWidth(imageRef.current.clientWidth);
  }, [imageHeight]);

  async function capture() {
    setCamImageWithBg(webCamRef.current.getScreenshot());
    new Audio(sound).play();

    // const [track] = webCamRef.current.stream.getVideoTracks();
    // let image = new ImageCapture(track);
    // try {
    //   const blob = await image.takePhoto();
    //   setCamImageWithBg(URL.createObjectURL(blob));
    //   setTimeout(() => {
    //     new Audio(sound).play();
    //   }, 50);
    // } catch (err) {
    //   throw err;
    // }
  }

  const clickAgain = () => {
    selectFrame(Frames[0]);
    setCamImage(null);
    setCamImageWithBg(null);
    setProgress(0);
    setUrl(null);
    setProgress(0);
    setShowModal(false);
    setTempImage(null);
    setUpload(false);
  };

  // const next = () => {
  //   setProgress(progress + 3);
  // };

  const handleImageUpload = async () => {
    if (!loading) {
      setLoading(true);
      // const body = new FormData();
      // body.append("size", "preview");
      // body.append("image_file_b64", camImageWithBg);

      // const res = await removeBg(camImageWithBg);
      setLoading(false);
      setUrl(true);
      // if (res) {
      // const blob = new Blob([res.data]);
      // const blobUrl = URL.createObjectURL(blob);

      setCamImageWithBg(camImageWithBg);
      setUpload(true);
      // }
    }
  };

  useEffect(() => {
    if (upload) {
      async function upload() {
        const canvas = await html2canvas(imageFrameRef.current, { scale: 2 });
        const dataUrl = canvas.toDataURL("image/jpeg");
        setImgCompress(dataUrl);
        const body2 = new FormData();
        body2.append("image", dataUrl);
        body2.append("eventname", photoboothName);
        uploadImage({
          body: body2,
          setError,
          setUrl,
        });
      }

      upload();
    }
  }, [upload]); // eslint-disable-line

  useEffect(() => {
    document.title = "Photobooth";
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line

  const handleImageDownload = () => {
    saveAs(imgCompress, `${photoboothName}.jpeg`);
  };

  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  const handleShareImage = async () => {
    if (navigator.share) {
      const blob = await (await fetch(imgCompress)).blob();
      await navigator
        .share({
          files: [
            new File([blob], "DigitalPhotobooth.jpg", {
              type: blob.type,
            }),
          ],
          title: "Digital-Photobooth",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error in sharing", error));
    } else {
      console.log(`system does not support sharing files.`);
    }
  };

  const handleCloseModel = () => {
    setShowModal(false);
  };

  const handleSwitchCamera = () => {
    setTempImage(webCamRef.current.getScreenshot());
    let count = 0;
    setLoading(true);
    intervalRef.current = setInterval(() => {
      if (count++ === 0) {
        setCamera((prev) =>
          prev === "user" ? { exact: "environment" } : "user",
        );
      } else {
        setTempImage(null);
        setLoading(false);
        clearInterval(intervalRef.current);
      }
    }, 500);
  };

  const CaptureActionBlock = () =>
    !camImageWithBg ? (
      <div className="actionBlock" style={{ bottom: 100 }}>
        <div className="text-center mT30 mB30 btnsOuter">
          <button
            disabled={loading}
            className="rippleBtn"
            style={{ backgroundColor: "#e11a22" }}
            onClick={capture}
          >
            Capture Photo
            <span style={{ padding: "0 0px 0 10px" }}>
              <img src={CamIcon} alt="" />
            </span>
          </button>
          <button
            disabled={loading}
            className="rippleBtn"
            onClick={handleSwitchCamera}
            style={{ backgroundColor: "#e11a22" }}
          >
            <span>
              <img src={switchCamera} alt="" />
            </span>
          </button>
        </div>
      </div>
    ) : (
      <div className="actionBlock btnAction" style={{ bottom: 100 }}>
        <div className="text-center mT30 btnsOuter">
          {error && false ? (
            <span className="server-err">Someting went wrong</span>
          ) : (
            <>
              <button
                className="rippleBtn clickAgain mR10"
                disabled={loading}
                onClick={clickAgain}
                style={{ backgroundColor: "#e11a22" }}
              >
                Click Again
              </button>
              {url ? (
                <button
                  className="rippleBtn share mR10"
                  onClick={handleShareImage}
                  style={{ backgroundColor: "#e11a22" }}
                >
                  <span>Share</span>
                </button>
              ) : null}
              <button
                className="rippleBtn mR10"
                disabled={loading}
                // onClick={clearBackground}
                onClick={url ? handleImageDownload : handleImageUpload}
                style={{ backgroundColor: "#e11a22" }}
              >
                {loading ? <ButtonLoader /> : url ? "Download" : "View"}
              </button>
            </>
          )}
        </div>
      </div>
    );

  const renderInitial = () => (
    <>
      <div
        className={`framephotobooth ${camImage ? "finalView" : ""}`}
        style={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div
          className="descpertionSec takephotoSec"
          ref={imageFrameRef}
          style={
            imageHeight
              ? { height: imageHeight, display: "flex", alignItems: "center" }
              : {}
          }
        >
          {camImage || tempImage ? (
            <div className="pictureArea dynmaicBg">
              <img className="capturePic" src={camImage || tempImage} alt="" />
            </div>
          ) : imageHeight ? (
            <>
              <div
                className={camImageWithBg ? "d-none" : ""}
                style={{ position: "inherit", zIndex: 2 }}
              >
                <Webcam
                  {...webCamSettings}
                  videoConstraints={{
                    facingMode: camera,
                    aspectRatio: 1.5,
                    style: imageWidth ? { width: imageWidth } : {},
                  }}
                  style={imageWidth ? { width: imageWidth } : {}}
                  mirrored={camera === "user"}
                  ref={webCamRef}

                  // width={{ min: 10, ideal: 1080, max: 1920 }}
                  // height={{ min: 57, ideal: 1920, max: 1080 }}
                />
              </div>
              <img
                style={{
                  position: "inherit",
                  zIndex: 2,
                  width: imageWidth || "auto",
                }}
                className={camImageWithBg ? "capturePic" : "d-none"}
                src={camImageWithBg}
                alt=""
              />
            </>
          ) : null}

          <div className="frameV2" style={{ zIndex: 1, height: imageHeight }}>
            <img
              // style={imageHeight ? { height: "100%" } : {}}
              style={{ display: "none" }}
              className="capturePic"
              onLoad={handleImageHeight}
              src={bg === "1" ? bg1 : bg2}
              alt=""
            />
          </div>
          <div className="frameV2" style={{ zIndex: 3, height: imageHeight }}>
            <img
              style={imageHeight ? { height: "100%" } : {}}
              ref={imageRef}
              className="capturePic"
              onLoad={handleImageHeight}
              src={selectedFrame}
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <section className="wrapper ellipse-bg">
        <button
          disabled={loading}
          style={{
            position: "absolute",
            top: 10,
            left: 10,
            backgroundColor: "#e11a22",
          }}
          className="rippleBtn"
          onClick={() => window.location.replace(APP_LINK)}
        >
          Back
        </button>
        <div className="container">
          <div className="framephotoboothOuter">
            <div className="fixedActions">
              {/* <button
              className="rippleBtn"
              disabled={loading}
              onClick={() => navigate("/gallery")}
            >
              Gallery
            </button> */}
            </div>
            {renderInitial()}
          </div>
        </div>

        <Modal
          ariaHideApp={false}
          className="modal2"
          isOpen={showModal}
          onRequestClose={handleCloseModel}
          overlayClassName="overlay2"
          style={customModalStyles}
        >
          <div className="text-center ">
            <div>
              <img src={url} alt="" />
            </div>
            <div style={{ color: "#19062a", fontWeight: 600 }}>Share on</div>
            <div className="modalActions">
              <EmailShareButton url={url}>
                <span>
                  <img src={Email} alt="" />{" "}
                </span>
              </EmailShareButton>

              <FacebookShareButton url={url}>
                <span>
                  <img src={Facebook} alt="" />{" "}
                </span>
              </FacebookShareButton>

              <LinkedinShareButton url={url}>
                <span>
                  <img src={Linkedin} alt="" />{" "}
                </span>
              </LinkedinShareButton>

              <TwitterShareButton url={url}>
                <span>
                  <img src={Twitter} alt="" />{" "}
                </span>
              </TwitterShareButton>

              <WhatsappShareButton url={url}>
                <span>
                  <img src={Whatsapp} alt="" />{" "}
                </span>
              </WhatsappShareButton>
            </div>
          </div>
        </Modal>

        <div id="warning-message">
          This photo-booth is only viewable in mobile portrait mode.
        </div>
      </section>
      {progress === 0 && imageHeight ? <CaptureActionBlock /> : null}
    </>
  );
}
